import { render, staticRenderFns } from "./DebtsData.vue?vue&type=template&id=7fbc6ce5&scoped=true"
import script from "./DebtsData.vue?vue&type=script&lang=js"
export * from "./DebtsData.vue?vue&type=script&lang=js"
import style0 from "./DebtsData.vue?vue&type=style&index=0&id=7fbc6ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc6ce5",
  null
  
)

export default component.exports